module.exports = __webpack_public_path__ + "img/pig7.e6e26cdd.png";